import { LoadingController, Loading } from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerProvider {

  private spinner: Loading = null;

  constructor(public loading: LoadingController) {

  }

  Show(message: string, tempo: number = 600000): void {
    if (this.spinner == null) {
      this.spinner = this.loading.create({ content: (message || 'Carregando...'), duration: tempo });
      this.spinner.present();
    }
    else {
      this.spinner.data.content = message;
    }
  }

  Hide(): void {
    if (this.spinner != null) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/spinner/spinner.ts